/**
 * Reducer du parcours d'inscription AICI client.
 * Convention maison : constantes d'action SCREAMING_SNAKE co-localisées, reducer en switch.
 * On n'y stocke qu'un instantané léger et sérialisable (étape courante + clé du contact),
 * afin que le stepper et la reprise fonctionnent immédiatement après un refresh
 * (redux-persist), sans attendre le fetch serveur du TeachrContact.
 * Les données métier durables restent canoniques côté serveur (TeachrContact).
 */
export const SET_AICI_ONBOARDING_INFO = 'SET_AICI_ONBOARDING_INFO';
export const RESET_AICI_ONBOARDING_INFO = 'RESET_AICI_ONBOARDING_INFO';

export interface AiciOnboardingState {
    /** Étape courante (1-indexée). */
    step: number;
    /** Clé du TeachrContact en cours, pour ne réutiliser l'instantané que pour le bon contact. */
    key: string | null;
}

const initialState: AiciOnboardingState | null = null;

export function aiciOnboardingReducers(
    state: AiciOnboardingState | null = initialState,
    action: any
): AiciOnboardingState | null {
    switch (action.type) {
        case SET_AICI_ONBOARDING_INFO:
            return action.payload;
        case RESET_AICI_ONBOARDING_INFO:
            return null;
        default:
            return state;
    }
}
